module.exports = __webpack_public_path__ + "static/media/Eclipse.b74e6708.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Collections/Eclipse.gif
// module id = 664
// module chunks = 0